import request from '@apps-common/js-client/api/request';
import {useQuery} from '@tanstack/react-query';

const getCollections = (dataset = 'boundaries') =>
  request.get(`/features/v1/ogc/${dataset}/collections`).then(res => res.data);

export const useGetCollections = () =>
  useQuery({
    queryKey: ['featureCollections'],
    queryFn: () => getCollections(),
    select: data => {
      // large collections can cause issues downstream, filter until we figure out a better answer
      // knock on #da-css door if this comes up.
      const filtered = data.collections.filter(
        collection => collection.feature_count <= 50
      );

      return {
        ...data,
        collections: filtered,
      };
    },
  });

const getCollection = (collectionId, dataset = 'boundaries') =>
  request
    .get(`/features/v1/ogc/${dataset}/collections/${collectionId}`)
    .then(res => res.data);

export const useGetCollection = ({collectionId}, queryOptions = {}) =>
  useQuery({
    queryKey: ['featureCollections', collectionId],
    queryFn: () => getCollection(collectionId),
    ...queryOptions,
  });
